import type { SSOAttribute } from '../types';

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isAttributeUuid(value: string): boolean {
  return UUID_RE.test(String(value || '').trim());
}

type AttributeCatalogEntry = Pick<SSOAttribute, 'id' | 'name' | 'display_name'> &
  Partial<Pick<SSOAttribute, 'okta_attribute_key'>>;

/** Map attribute id / name → display label for chips and summaries. */
export function resolveAttributeReleaseLabel(
  raw: string,
  catalog: AttributeCatalogEntry[],
): string {
  const v = String(raw || '').trim();
  if (!v) return v;

  const byId = catalog.find(a => a.id === v);
  if (byId) return byId.display_name || byId.name;

  const normalized = v.replace(/^user\./i, '');
  const byName = catalog.find(
    a =>
      a.name === v ||
      a.name === normalized ||
      a.display_name === v ||
      a.okta_attribute_key === v,
  );
  if (byName) return byName.display_name || byName.name;

  // Legacy plain names (email, firstName) — title-case for readability
  if (!isAttributeUuid(v) && !v.includes('.')) {
    return v.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }

  return v;
}

export function resolveAttributesToReleaseLabels(
  values: string[] | undefined,
  catalog: AttributeCatalogEntry[],
): string[] {
  if (!values?.length) return [];
  return values.map(v => resolveAttributeReleaseLabel(v, catalog));
}
